<template>
  <TransitionGroupSlide :active="enabledTransition" class="diy-topbar__menu-wrapper">
    <!-- main menu -->
    <TheTopbarNavbarMenuMain
      v-if="selectedMenu === 'TheTopbarNavbarMenuMain'"
      key="main"
      @menu-selected="actionRequested"
    />
    <!-- account menu -->
    <TheTopbarNavbarMenuAccount
      v-if="selectedMenu === 'TheTopbarNavbarMenuAccount'"
      key="account"
      @menu-selected="actionRequested"
    />
  </TransitionGroupSlide>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
// Components
import TransitionGroupSlide from 'Components/TransitionGroupSlide'
import TheTopbarNavbarMenuMain from './TheTopbarNavbarMenuMain'

export default {
  name: 'TheTopbarNavbarMenu',

  components: {
    TransitionGroupSlide,
    TheTopbarNavbarMenuMain,
    TheTopbarNavbarMenuAccount: () => import('./TheTopbarNavbarMenuAccount'),
  },

  data() {
    return {
      enabledTransition: false,
      selectedMenu: 'TheTopbarNavbarMenuMain',
    }
  },

  methods: {
    actionRequested(component) {
      if (!this.enabledTransition) this.enabledTransition = true
      this.selectedMenu = component
      if (!component) this.$emit('clicked')
    },
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.user.currentUser,
      currentAccount: (state) => state.client.account || null,
    }),
  },
}
</script>

<style scoped>
.diy-topbar__menu-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  padding: 8px;
  background-color: #fff;
  transition: height 0.3s;
}
</style>
